module.exports = __webpack_public_path__ + "img/ic-star.dd36399a.svg";